import React, { useState } from 'react';
const faqs = [{
  q: '¿Cómo recibo el material?',
  a: 'El acceso es inmediato. Apenas se confirma tu pago, recibes un email con el link para descargar todo el kit en tu celular, tablet o computadora.'
}, {
  q: '¿Sirve si soy profesora principiante?',
  a: '¡Totalmente! Es ideal para darte seguridad en tus primeras clases. Tienes la estructura armada, las secuencias lógicas y los temas listos para usar.'
}, {
  q: '¿Para qué estilos de yoga sirve?',
  a: 'Las clases están diseñadas principalmente para Hatha y Vinyasa, con opciones de adaptabilidad. Además incluye un módulo específico de Yoga Terapéutico.'
}, {
  q: '¿Los bonos están incluidos en los $22 USD?',
  a: 'Sí, los 5 bonos (Rituales, Música, Ajustes, Captions y Tracker) están incluidos 100% gratis con tu compra de hoy.'
}, {
  q: '¿En qué formato están los archivos?',
  a: 'Todo el material está en formato PDF de alta calidad, listo para leer en cualquier dispositivo o para imprimir si prefieres el papel.'
}, {
  q: '¿Tengo que pagar una mensualidad?',
  a: 'No, es un pago único. Una vez que lo compras, el material es tuyo para siempre. No hay suscripciones ni cobros ocultos.'
}, {
  q: '¿Qué pasa si no me gusta?',
  a: 'Tienes 7 días de garantía total. Si sientes que el material no te sirve, nos mandas un email y te devolvemos el 100% de tu dinero sin hacer preguntas.'
}];
export function FAQSection() {
  const [openIndex, setOpenIndex] = useState<number | null>(null);
  return <section className="w-full bg-bg-alt py-20 sm:py-24 px-4" data-id="element-77">
      <div className="max-w-3xl mx-auto" data-id="element-78">
        <div className="text-center mb-12" data-id="element-79">
          <h2 className="text-3xl sm:text-5xl font-serif font-black text-text-main" data-id="element-80">
            Preguntas Frecuentes
          </h2>
        </div>

        <div className="space-y-4" data-id="element-81">
          {faqs.map((faq, i) => {
          const isOpen = openIndex === i;
          return <div key={i} className="bg-bg-main border border-border-light rounded-2xl overflow-hidden" data-id="element-82">
                <button className="w-full text-left px-6 py-5 flex items-center justify-between gap-4" onClick={() => setOpenIndex(isOpen ? null : i)} data-id="element-83">
                  <span className="font-bold text-text-main text-lg" data-id="element-84">
                    {faq.q}
                  </span>
                  <span className={`text-2xl text-primary transition-transform ${isOpen ? 'rotate-45' : ''}`} data-id="element-85">
                    +
                  </span>
                </button>
                <div className={`px-6 overflow-hidden transition-all duration-300 ${isOpen ? 'max-h-96 pb-6 opacity-100' : 'max-h-0 opacity-0'}`} data-id="element-86">
                  <p className="text-text-sec text-base" data-id="element-87">{faq.a}</p>
                </div>
              </div>;
        })}
        </div>
      </div>
    </section>;
}